module.exports = __webpack_public_path__ + "media/mypage/images/logo-0f7d107128ce7b9f13db43a8c7501123.png";